import { render, staticRenderFns } from "./LogItem.vue?vue&type=template&id=b8ac454e&"
import script from "./LogItem.vue?vue&type=script&lang=js&"
export * from "./LogItem.vue?vue&type=script&lang=js&"
import style0 from "./LogItem.vue?vue&type=style&index=0&id=b8ac454e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports